import { useTheme } from '@mui/material';

import { themeColors } from '~/theme';

export const useSxStyles = () => {
  const theme = useTheme();

  const contentLayout = {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  };

  return {
    root: {
      padding: theme.spacing(1, 2),
      backgroundColor: themeColors.background.grey,
      ...contentLayout,
      height: '100%',
    },
    content: contentLayout,
  };
};
